module.exports = __webpack_public_path__ + "img/voucher_bg2.5ebcfb70.png";